import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const EndQuizModal = (({ numCorrect, numQuestions, graded, resetQuiz, setShowEndQuiz, liveQuiz }) => {
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (numCorrect && numQuestions) {

            const scorePercent = (parseInt(numCorrect) / parseInt(numQuestions)).toFixed(2);

            if (scorePercent === 100.00) {
                setMessage("Perfect Quiz! Outstanding.")
            } else if (scorePercent >= 0.90) {
                setMessage("Excellent job!");
            } else if (scorePercent >= 0.80) {
                setMessage("That's pretty solid.");
            } else if (scorePercent >= 0.70) {
                setMessage("Mediocre.");
            } else if (scorePercent >= 0.65) {
                setMessage("You technically passed. Barely.");
            } else {
                setMessage("Well, you took the quiz and that's what counts.");
            }
        }
    }, [numCorrect, numQuestions])

    const handleReset = (e) => {
        resetQuiz(e);
    }

    const handleReview = () => {
        setShowEndQuiz(false);
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h3>Quiz Completed</h3>

                {graded && <h4>{`You scored: ${numCorrect}/${numQuestions}`}</h4>}
                <p>{graded ? message : "Great job finishing the quiz, review your answers or reset for another round."}</p>

                <div className="d-flex justify-content-evenly">
                    <Button className="quiz-btn-dark me-2" onClick={() => handleReview()}>
                        <FontAwesomeIcon icon={faMagnifyingGlass} className='me-2' />
                        Review
                    </Button>

                    <Button onClick={(e) => handleReset(e)} className="quiz-btn">
                        <FontAwesomeIcon icon={faRotateLeft} className='me-2'/>
                        {liveQuiz ? "Return to game room" : "Reset Quiz"}
                    </Button>
                </div>
            </div>
        </div>
    );
})

export default EndQuizModal